import { render, staticRenderFns } from "./MobileMenuContent.vue?vue&type=template&id=05bdcb36&scoped=true&"
import script from "./MobileMenuContent.vue?vue&type=script&lang=js&"
export * from "./MobileMenuContent.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuContent.vue?vue&type=style&index=0&id=05bdcb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bdcb36",
  null
  
)

export default component.exports